var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenifits4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6823 18.1152H41.2526L37.6006 26.4229",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1191 23.971H22.9022C22.9022 23.971 25.6643 18.9643 26.1201 18.405C26.5811 17.8395 27.0175 18.1922 27.0591 18.6911C27.1007 19.1899 27.0383 26.4229 27.0383 26.4229",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5513 26.4848C21.5513 26.4848 17.5093 26.5355 17.3178 26.4718C17.1264 26.4079 17.6247 26.0708 20.2748 22.2844C20.7697 21.5772 21.0422 20.9807 21.158 20.4809L21.1991 20.1595C21.1991 18.9854 20.2474 18.0337 19.0734 18.0337C18.0403 18.0337 17.1793 18.7706 16.9875 19.7475",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8384 18.1152L30.5019 26.5042",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37863 27.2382C1.24582 24.6898 0.539956 22.0061 0.778823 19.4815C0.838296 18.8536 1.12902 18.27 1.57501 17.8241L5.2548 14.1443C6.30773 13.0914 8.04992 13.2182 8.93927 14.4125L13.0957 19.9378C13.5399 20.5283 13.4748 21.3571 12.9438 21.871L10.2514 24.4766C9.92082 24.7964 9.85832 25.3035 10.1013 25.6941V25.6942C13.6847 31.4554 18.5448 36.3155 24.306 39.8989C24.6965 40.1418 25.2036 40.0793 25.5235 39.7488L28.129 37.0564C28.6429 36.5255 29.4718 36.4604 30.0623 36.9045L35.5876 41.0609C36.7819 41.9503 36.9087 43.6925 35.8558 44.7454L32.176 48.4252C31.714 48.8871 31.1036 49.1701 30.4528 49.2274C21.5848 50.0084 10.7883 39.212 10.7883 39.212C10.7883 39.212 6.86125 35.285 3.91525 30.2223",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5554 8.66213C22.7243 2.23576 33.7517 2.46769 40.642 9.35803C47.7725 16.4885 47.7725 28.0491 40.642 35.1796C38.6544 37.1672 36.3227 38.6007 33.8385 39.4802",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.498 16.2233C11.147 14.3689 12.1041 12.5983 13.3694 10.9912",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9388 8.08545C51.3565 16.545 51.0301 29.4269 42.9597 37.4972C41.0484 39.4084 38.8673 40.8854 36.539 41.9279",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08624 13.4292C9.12804 11.1128 10.6002 8.94282 12.5027 7.04028C20.4808 -0.937743 33.1609 -1.348 41.6226 5.80972",
    stroke: "#00C8FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenifits4);
export default __webpack_public_path__ + "static/media/benifits4.8754647ba714ad336325da9eb874a8a1.svg";
export { ForwardRef as ReactComponent };